<template>
	<div :class="visible ? 'visible-transition' : 'invisible-transition'">
		<p :class="extra ? 'extra ' + titleClass : titleClass" v-if="title">{{ title }}</p>
		<h2 :class="preClass" v-if="pre">{{ pre }}</h2>
		<h2 :class="numberClass">
			<i-count-up :start="startVal"
						      :end="myEndVal"
							  :decimals="decimals"
						      :duration="duration"
						      :options="options"
							  :callback="countUp">
			</i-count-up>
		</h2>
		<h2 :class="postClass" v-if="post">{{ post }}</h2>
		<p :class="extra ? 'extratop ' + subtitleClass : subtitleClass" v-if="subtitle">{{ subtitle }} <span v-if="subtitle2"><br>{{ subtitle2 }}</span></p>
	</div>
</template>

<script>
	import ICountUp from 'vue-countup-v2';

	export default {
		components: {
      ICountUp
    },
    props: {
	    visible: {
        default: () => false
	    },
	    title: {
        default: () => false
	    },
	    titleClass: {
        default: () => null
	    },
	    subtitle: {
        default: () => false
	    },
	    subtitle2: {
        default: () => false
	    },
	    subtitleClass: {
        default: () => null
	    },
	    startVal: {
        default: () => 0
	    },
	    endVal: {
        default: () => 0
	    },
	    numberClass: {
        default: () => null
	    },
	    pre: {
        default: () => false
	    },
	    preClass: {
        default: () => null
	    },
	    post: {
        default: () => false
	    },
	    postClass: {
        default: () => null
	    },
	    decimals: {
        default: () => null
	    },
	    separator: {
        default: () => ','
	    },
	    duration: {
        default: () => 0
	    },
	    extra: {
        default: () => false
	    }
		},
		data() {
      return {
	      myEndVal: 0,
        options: {
          useEasing: 		true,
          useGrouping: 	true,
          separator: 		this.separator,
          decimal: 			',',
          prefix: 			'',
          suffix: 			''
        }
      }
    },
    methods: {
	    countUp: function(ins) {}
    },
    watch: {
		  visible: function(val) {
			  if(val) {
				  this.myEndVal = this.endVal;
			  }else{
				  this.myEndVal = 0;
			  }
		  }
	  }
	}
</script>
